import "core-js/modules/es.array.push.js";
/**
 * Container do Google Tag Manager (GTM):
 * https://tagmanager.google.com/#/container/accounts/6052753775/containers/90770280
 */

function enviar(parametros) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(parametros);
}
function evento(nome) {
  enviar({
    "event": nome
  });
}
export default {
  enviar: enviar,
  evento: evento
};